<!-- Gallery -->
<div infiniteScroll
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="50"
     (scrolled)="onScroll()" class="row">

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 py-3" *ngFor="let album of eventAlbum">
        <a href="#"
           title="Click here to enlarge."
           data-toggle="modal"
           data-target="#modal-gallery-family"
           [attr.data-index]="album.ImageIndex">
            <img class="cover res-img"
                 height="160"
                 [src]="album.ImagePath"
                 alt="" />
        </a>
    </div>
</div>
<div class="row pt-3">
    <div class="col-md-12 p-3">
        <ngx-spinner bdOpacity=0.9
                     bdColor=""
                     size="default"
                     color="#581f87"
                     type="ball-pulse-sync"
                     [fullScreen]="false">
        </ngx-spinner>
    </div>
</div>
